/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API11935Req {
  
  /**  */
  userPhone?: string;
  /**  */
  userPasswd?: string;
  /** PROAUTH:权限中心 */
  projectId?: string;
  /** 灰度平台，默认用户全平台灰度 */
  grayPlatform?: string;
};



export interface API11935Res {
  /**   */
  bizUserId: string;
  /**   */
  createdAt: string;
  /**   */
  id: number;
  /**   */
  isOut: string;
  /**   */
  status: string;
  /**   */
  updatedAt: string;
  /**   */
  userEmail: string;
  /** 用户id  */
  userId: string;
  /** 花名  */
  userName: string;
  /** 手机号  */
  userPhone: string;
  /** 用户token  */
  userToken: string;
  /** 是否是灰度用户  */
  beta: boolean;
  /** 是否切换为新平台  */
  isNewPlatform: boolean;
  /** 是否服务灰度  */
  isGray: boolean;
  
};


// 11935 用户登录

export interface IUsePostAPI11935Return {
  /** 用户登录: 接口请求状态 */
  isAPI11935Loading: boolean;
  /** 用户登录: 接口请求返回数据 */
  dataAPI11935: API11935Res;
  /**  用户登录: 接口数据请求方法 */
  fetchAPI11935Data:  (inputs: API11935Req, config?: YWRequestConfig) => Promise<API11935Res>;
  /** 用户登录: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI11935 = ():IUsePostAPI11935Return => {
  let isMount = true;
  const [isAPI11935Loading, setIsAPI11935Loading] = useState(false);
  const [dataAPI11935, setDataAPI11935] = useState<API11935Res>({} as API11935Res);
  const requestUrl = `${basePath}/ywwl-admin/user/login`;

  const fetchAPI11935Data = async (inputs: API11935Req, config?: YWRequestConfig): Promise<API11935Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API11935Req>) || {}) as API11935Req;
    
  
    if ( isMount ) {
      setIsAPI11935Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API11935Res>(`${basePath}/ywwl-admin/user/login`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI11935(res || {} as API11935Res);
        setIsAPI11935Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI11935Loading(false);
      }
      return false as unknown as API11935Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI11935Loading,
    dataAPI11935,
    fetchAPI11935Data,
    requestUrl,
  }
}

